const userspecialdiet = {
    getlist: 'userspecialdiet/getlist',
    add: 'userspecialdiet/add',
    update: 'userspecialdiet/update',
    remove: 'userspecialdiet/remove',
    get: 'userspecialdiet/get-by-admin',
    dietDurationAll: 'dietduration/getall',
    excel: 'userspecialdiet/getbyNutritionist',
}
export default userspecialdiet
